/**
 * Stades du stock bouteilles (Lot D) — libellés FR + helpers partagés.
 *
 * Règle D.0 : le stock bouteilles s'affiche TOUJOURS ventilé par stade
 * (sur lattes / sur pointes / dégorgées nues / habillées). Le total n'est
 * jamais affiché SEUL — uniquement en complément de la ventilation.
 * Consommé par : hub Cave, liste/fiche cuvées, widget dashboard.
 */

import type { LotStade, StockParStade } from "@champ-erp/contracts";

/** Libellés FR des stades — miroir de `lotStadeSchema` (contrats). */
export const STADE_LABELS: Record<LotStade, string> = {
  sur_lattes: "Sur lattes",
  sur_pointes: "Sur pointes",
  degorgee: "Dégorgées nues",
  habillee: "Habillées",
};

/** Ordre d'affichage = ordre du flux de cave (lattes → pointes → dégorgé → habillé). */
export const STADES_ORDONNES: readonly LotStade[] = [
  "sur_lattes",
  "sur_pointes",
  "degorgee",
  "habillee",
];

/** Nombre de bouteilles au format FR (séparateur de milliers) : 12400 → "12 400". */
export function formatNbBouteilles(nb: number): string {
  return new Intl.NumberFormat("fr-FR").format(nb);
}

/** Somme des 4 stades — toujours affichée EN COMPLÉMENT de la ventilation. */
export function totalBouteilles(stock: StockParStade): number {
  return STADES_ORDONNES.reduce((acc, stade) => acc + stock[stade], 0);
}
